// Event data
// TODO - Pending GTM update?

function addToCartEventAction(payload) {
  /* Get the product data */
  // console.log('addToCartEventAction - payload => ', payload)
}
